import BaseCurl from '../curl';
import storage from '$common/utils/storage';
import languageUtils from '$common/utils/language';
import AcstaticDunAntiCheating from '../acstatic-dun-anti-cheating';
import { urlQueries } from '../../url/url'

class UserTerminalCurl extends BaseCurl {
  constructor(...args) {
    super(...args);
    this.language = languageUtils.getPageHeaderCurrentLanguage;
    //  需要重定向到
    this.notLoggedIn = ['O2051', 'O2053', 'O2052', 'O2050'];
    this.loginKeys = ['refreshToken', 'accessToken', 'operatorNo', 'nickName', 'loginName', 'operatorType'];
    this.user = {};
    this.antiCheating = new AcstaticDunAntiCheating();
    // 默认不隐藏提示信息
    this.hideErrorMsg = () => false;
    for (const userkey of this.loginKeys) {
      const __value = storage.getItem(userkey);
      if (__value) {
        this.user[userkey] = __value;
      }
    }
  }
  sendError(msg, rspCd = '', data) {
    // 配置了隐藏错误信息则不提示
    if (msg && !this.hideErrorMsg(rspCd, data)) {
      Vue.filter('show-message')({
        content: msg
      });
    }
  }
  processErrorMsg(rspInf, rspCd, data) {
    if (data && typeof data === 'object') {
      Object.keys(data).forEach(key => {
        rspInf = rspInf.replace(new RegExp('{' + key + '}'), data[key])
      })
    }
    return [rspInf, rspCd, data]
  }
  //  处理结果中返回的异常
  processResponseResult(res, config) {
    const { rspCd, rspInf, data, rspType } = res;
    const { isNotSendError = false, isNotLogin = false } = config;
    // 占位符 rspType == 1 处理
    // 先去 rspInf 中获取占位标识 key,再到 data 中获取值,最后替换回 rspInf 中
    if (rspType.toString() === '1') {
      // !isNotSendError && this.sendError(rspInf, rspCd, data);
      !isNotSendError && this.sendError(...this.processErrorMsg(rspInf, rspCd, data));
    } else if (rspCd.toString() === '10000' && Array.isArray(data)) {
      // 状态码 10000 标识多个异常处理
      !isNotSendError && data.forEach(e => this.sendError(e.rspInf, e.rspCd, data));
    } else if (this.notLoggedIn.indexOf(rspCd.toString()) !== -1) {
      console.log('\n\nnot logged in rspInf: ', res);
      storage.setItem('errorRes', res);
      // this.sendError(rspInf, rspCd);
      !isNotLogin && this.goLogin();
    } else if (/^[A-Za-z]\d{4}$/.test(rspCd.toString())) {
      !isNotSendError && this.sendError(rspInf, rspCd, data);
    } else if (rspCd.toString() !== '00000' && rspCd.toString() !== 'success') {
      !isNotSendError && this.sendError(rspInf, rspCd, data);
    }
  }
  goLogin() {
    const userInfo = storage.getItem('userInfo');
    const appNo = userInfo?.appNo ?? 21;
    const wechatId = userInfo?.wechatId || '';
    storage.clear();
    if (appNo.toString() === '20' && wechatId) {
      window.location.href = `/mobile-h5/module/${wechatId}/wechat/authorization?callback=${encodeURIComponent(window.location.href)}`
    } else {
      if (process.env.NODE_ENV === 'development') {
        window.location.href = `/super/app/user/v1/index/login?callback=${encodeURIComponent(window.location.href)}`;
        return;
      }
      window.location.href = `/mobile-h5/super/app/user/v1/login?callback=${encodeURIComponent(window.location.href)}`;
    }
  }
  curl(params = {}, url, config = {}) {
    if (config.hideErrorMsg && typeof config.hideErrorMsg === 'function') {
      this.hideErrorMsg = config.hideErrorMsg
    }
    return this.antiCheating.checkAcstaticDunAntiCheating(url).then(antiCheatingResult => {
      const { isBlockException = false, success = () => {}, header = {}, fail = () => {}, error = () => {}, method = 'post' } = config;
      if (JSON.stringify(this.user) === '{}' && ['/login', '/phone-recharge', '/register'].filter(e => window.location.pathname.indexOf(e) === -1).length === 0) {
        return new Promise((resolve, reject) => {
          this.goLogin();
          resolve();
        });
      }
      const data = {};
      const __params = {};
      const forPar = Object.assign({}, params, {
        loginName: params.loginName || (this?.user?.loginName) || ''
      });
      if (window.location.href.indexOf('visitChannel=') !== -1) {
        let __visitChannel = window.location.href.split('visitChannel=')[1];
        __visitChannel = __visitChannel.split(/\'|\"|\`|&/)[0];
        if (__visitChannel) {
          forPar.visitChannel = __visitChannel;
        }
      }
      Object.keys(forPar).filter(e => !(!forPar[e] && forPar[e] !== 0)).forEach(e => {
        __params[e] = forPar[e];
      })
      //  需要做反作弊操作
      if (antiCheatingResult.isAntiCheating) {
        data.riskToken = this.antiCheating.currentToken.value;
      }
      for (const itemKey of Object.keys(__params)) {
        data[itemKey] = __params[itemKey] === 0 && '0' || undefined;
        data[itemKey] = !(__params[itemKey] === undefined || __params[itemKey] === null) && __params[itemKey] || '';
      }
      const curl = this.getCurl(data);
      const queries = urlQueries()
      const { accessToken: token } = queries
      const dataStr = encodeURIComponent(JSON.stringify(data));
      const curlOptions = {
        method: dataStr.length <= 400 && url.indexOf('gateway_web') !== -1 ? 'get' : 'post',
        url,
        headers: Object.assign({}, {
          appNo: storage.getItem('appNo') || 21,
          loginName: this?.user?.loginName ?? storage.getItem('loginName') ?? '',
          operatorNo: this?.user?.operatorNo ?? storage.getItem('operatorNo') ?? '',
          accessToken: this?.user?.accessToken ?? storage.getItem('accessToken') ?? token ?? ''
        }, header)
      };
      if (curlOptions.method.toLocaleLowerCase() === 'get') {
        curlOptions.url = `${curlOptions.url}?${dataStr}`;
      } else {
        curlOptions.data = data;
      }
      return curl(curlOptions).then(res => {
        try {
          if (!isBlockException && !!res?.data?.rspCd) {
            this.processResponseResult(res?.data ?? res, config);
          }
        } catch (error) {}
        const result = res?.data ?? res;
        if ((result?.rspInf ?? '') === 'success' && (result?.rspCd ?? '') === '00000') {
          success?.(result?.data || {}, result?.rspInf || '', result);
        } else {
          fail(res?.data ?? undefined);
        }
        return result;
      }).catch(err => {
        if (err.toString().indexOf('404') !== -1) {
          this.sendError('Page does not exist!');
        } else {
          error?.(err);
        }
      }).finally(res => {
        //  需要做反作弊操作
        if (antiCheatingResult.isAntiCheating) {
          this.antiCheating.setTokenUsed();
        }
        return res;
      });
    }).catch(err => {
      return {
        rspCd: '99999',
        rspInf: err,
        data: null,
        rspType: '0',
        v: '1',
        responseTm: this.antiCheating.getCurrentTime()
      }
    });
  }
}
export default UserTerminalCurl
